var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"airwallex-card"},[_c('div',{ref:"card",attrs:{"id":"airwallex-card"}}),_vm._v(" "),_c('p',{ref:"error",attrs:{"id":"airwallex-error"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }